(() => {
  const config = document.getElementById('KotsanasCountryRouting');
  const form = document.getElementById('KotsanasLocationForm');
  if (!config || !form) return;

  const countries = new Set(config.dataset.countries.split(','));
  const current = config.dataset.country;
  const preferenceKey = 'kotsanas.manual-country.v1';
  const attemptKey = 'kotsanas.country-routing.v1';
  let manuallySelected = false;

  try {
    if (sessionStorage.getItem(attemptKey) === current) sessionStorage.removeItem(attemptKey);
  } catch {}

  const readPreference = () => {
    for (const storageName of ['localStorage', 'sessionStorage']) {
      try {
        const country = window[storageName].getItem(preferenceKey);
        if (countries.has(country)) return country;
      } catch {}
    }
    return null;
  };

  const rememberCountry = (country) => {
    if (!countries.has(country)) return;
    manuallySelected = true;
    try { sessionStorage.removeItem(attemptKey); } catch {}
    for (const storageName of ['localStorage', 'sessionStorage']) {
      try { window[storageName].setItem(preferenceKey, country); } catch {}
    }
  };

  document.addEventListener('click', (event) => {
    if (!event.isTrusted || !(event.target instanceof Element)) return;
    const link = event.target.closest('a[data-value]');
    const countryForm = link?.closest('form');
    if (countryForm && countryForm !== form && countryForm.querySelector('[name="country_code"]')) {
      rememberCountry(link.dataset.value);
    }
  }, true);

  document.addEventListener('change', (event) => {
    if (event.isTrusted && event.target instanceof HTMLSelectElement && event.target.name === 'country_code') {
      rememberCountry(event.target.value);
    }
  }, true);

  if (/^\/[a-z]{2,3}-[a-z]{2}(?:\/|$)/i.test(location.pathname)) return;
  if (/bot|crawler|spider|slurp|lighthouse/i.test(navigator.userAgent)) return;

  const selectCountry = (country) => {
    if (manuallySelected || country === current || !countries.has(country)) return;
    try {
      if (sessionStorage.getItem(attemptKey)) return;
      sessionStorage.setItem(attemptKey, country);
      if (sessionStorage.getItem(attemptKey) !== country) return;
    } catch {
      return;
    }
    form.querySelector('[name="country_code"]').value = country;
    const returnTo = form.querySelector('[name="return_to"]');
    if (returnTo) returnTo.value = location.pathname + location.search + location.hash;
    form.requestSubmit();
  };

  const preference = readPreference();
  if (preference) {
    selectCountry(preference);
    return;
  }

  const root = window.Shopify?.routes?.root || '/';
  const params = new URLSearchParams({ 'country[enabled]': 'true', 'country[exclude]': current });
  fetch(`${root.replace(/\/?$/, '/')}browsing_context_suggestions.json?${params}`, {
    credentials: 'same-origin',
    signal: AbortSignal.timeout(5000)
  })
    .then(response => response.ok ? response.json() : null)
    .then(data => {
      const suggestion = data?.suggestions?.[0];
      const country = suggestion?.parts?.country;
      if (!manuallySelected && !readPreference() && suggestion?.confidence >= 0.9 && country?.confidence >= 0.9) {
        selectCountry(country.handle);
      }
    })
    .catch(() => {});
})();
